module.exports = __webpack_public_path__ + "static/media/bfc-inside-the-club.a6aec09d.md";